import { render } from "./CommentCreatedNotification.vue?vue&type=template&id=eb22d2f2"
import script from "./CommentCreatedNotification.vue?vue&type=script&lang=js"
export * from "./CommentCreatedNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__